const FA_DIGITS = "۰۱۲۳۴۵۶۷۸۹";

/** Render the Latin digits in `value` as Persian digits (the app is RTL/Persian-first). */
export function faDigits(value: string | number): string {
  return String(value).replace(/\d/g, (d) => FA_DIGITS[Number(d)] ?? d);
}

/** A compact notification-badge count: Persian digits, capped at «۹+». */
export function faBadge(n: number): string {
  return n > 9 ? "۹+" : faDigits(n);
}

/** Local wall-clock `HH:MM` for an epoch-ms timestamp, in Persian digits —
 * the subtle time caption on chat bubbles. */
export function faTime(at: number): string {
  const d = new Date(at);
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return faDigits(`${hh}:${mm}`);
}
